import type { ComponentProps, PropsWithChildren } from 'react'
import { type TooltipProps, Tooltip as TamaguiTooltip } from 'tamagui'

export function Tooltip({
  children,
  placement = 'top',
  content,
  triggerProps,
  arrowProps,
  ...props
}: TooltipProps & {
  triggerProps?: ComponentProps<typeof TamaguiTooltip.Trigger>
  arrowProps?: ComponentProps<typeof TamaguiTooltip.Arrow>
  content?: PropsWithChildren['children']
}) {
  return (
    <TamaguiTooltip {...props} placement={placement}>
      <TamaguiTooltip.Trigger {...triggerProps}>{children}</TamaguiTooltip.Trigger>
      {content && (
        <TamaguiTooltip.Content
          enterStyle={{ x: 0, y: -5, opacity: 0, scale: 0.9 }}
          exitStyle={{ x: 0, y: -5, opacity: 0, scale: 0.9 }}
          scale={1}
          x={0}
          y={0}
          opacity={1}
          animation={['quick', { opacity: { overshootClamping: true } }]}
          style={{ padding: 0, backgroundColor: 'transparent' }}
        >
          <TamaguiTooltip.Arrow {...arrowProps} />
          {content}
        </TamaguiTooltip.Content>
      )}
    </TamaguiTooltip>
  )
}
